import { render, staticRenderFns } from "./Roomtype.vue?vue&type=template&id=cd9e95ce&"
import script from "./Roomtype.vue?vue&type=script&lang=js&"
export * from "./Roomtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports